<template>
  <div class="choice">
    <div class="choiceContent">
      <div class="title fontSize14">
        【{{ quesMap[info.type] }}】{{
          info.no ? info.no : Number(no) + 1
        }}、<span v-html="reformHtml(info.content)"></span>
      </div>
      <div class="list">
        <!-- 单选题 -->
        <template v-if="info.type == 'SINGLECHOICE'">
          <div
            v-for="(item, index) in info.options"
            :key="index"
            class="li"
            @click="choose(item.alisa)"
            :class="{
              'on': info.myAnswer == item.alisa && !readOnly,
              'right': info.myAnswer == item.alisa && readOnly && info.myAnswer == info.answer,
              'error': info.myAnswer == item.alisa && readOnly && info.myAnswer != info.answer,
            }"
          >
            <div class="unit d-flex d-flex-middle d-flex-center">
              {{ item.alisa }}
            </div>
            <div class="txt" v-html="item.text"></div>
          </div>
          <!-- 解析 -->
          <div class="analysisBox" v-if="readOnly">
            <div v-if="showAnswer">标准答案：{{ info.answer }}</div>
            <div v-if="showAnswer && answerExpose && (info.ext||info.analysis)">答案解析：<span v-html="info.ext||info.analysis"></span></div>
            <div>我的答案：{{ info.myAnswer }}</div>
          </div>
        </template>
        <!-- 多选题 -->
        <template v-if="info.type == 'MULTIPLECHOICE'">
          <div
            v-for="(item, index) in info.options"
            :key="index"
            class="li"
            @click="chooseM(item.alisa)"
            :class="{
              'on': info.myAnswer.indexOf(item.alisa) != -1 && !readOnly,
              'right': info.myAnswer.indexOf(item.alisa) != -1 && readOnly && info.answer.includes(item.alisa),
              'error': info.myAnswer.indexOf(item.alisa) != -1 && readOnly && !info.answer.includes(item.alisa),
            }"
          >
            <div class="unit d-flex d-flex-middle d-flex-center">
              {{ item.alisa }}
            </div>
            <div class="txt" v-html="item.text"></div>
          </div>
          <!-- 解析 -->
          <div class="analysisBox" v-if="readOnly">
            <div v-if="showAnswer">标准答案：{{ info.answer }}</div>
            <div v-if="showAnswer && answerExpose && (info.ext||info.analysis)">答案解析：<span v-html="info.ext||info.analysis"></span></div>
            <div>我的答案：{{ info.myAnswer.join("") }}</div>
            <!-- <div>我的答案：{{ info.myAnswer.split('').sort().join("") }}</div> -->

          </div>
        </template>
        <!-- 判断题 -->
        <template v-if="info.type == 'JUDGMENT'">
          <div
            class="li"
            @click="choose('Y')"
            :class="{
              'on': info.myAnswer == 'Y' && !readOnly,
              'right': info.myAnswer == 'Y' && readOnly && info.myAnswer == info.answer,
              'error': info.myAnswer == 'Y' && readOnly && info.myAnswer != info.answer,
            }"
          >
            <div class="unit d-flex d-flex-middle d-flex-center">A</div>
            <div class="txt">正确</div>
          </div>
          <div
            class="li"
            @click="choose('N')"
            :class="{
              'on': info.myAnswer == 'N'&& !readOnly,
              'right': info.myAnswer == 'N' && readOnly && info.myAnswer == info.answer,
              'error': info.myAnswer == 'N' && readOnly && info.myAnswer != info.answer,
            }"
          >
            <div class="unit d-flex d-flex-middle d-flex-center">B</div>
            <div class="txt">错误</div>
          </div>
          <!-- 解析 -->
          <div class="analysisBox" v-if="readOnly">
            <div v-if="showAnswer">标准答案：{{ info.answer == "N" ? "错误" : "正确" }}</div>
            <div v-if="showAnswer && answerExpose && (info.ext||info.analysis)">答案解析：<span v-html="info.ext||info.analysis"></span></div>
            <div>
              我的答案：<em v-if="info.myAnswer == 'Y'">正确</em>
              <em v-if="info.myAnswer == 'N'">错误</em>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import {quesMap} from '@/utils/enums'
export default {
  name: "choice",
  props: {
    info: {
      default: {},
    },
    no: {
      default: "",
    },
    readOnly: {
      default: false,
    },
    showAnswer:{
      default: false
    },
    answerExpose:{
      default: false
    }
  },
  data() {
    return {
      quesMap,
    };
  },
  methods: {
    reformHtml(html) {
      const regex = new RegExp('<img', 'gi');
      html= html.replace(regex, `<img style="max-width: 100%;"`);
      return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
    },
    choose(value) {
      if (!this.readOnly) {
        var data = {
          id: this.info.id,
          value: value,
        };
        this.$emit("choose", data);
      }
    },
    chooseM(value) {
      if (!this.readOnly) {
        var arry = JSON.parse(JSON.stringify(this.info.myAnswer)) || [];
        var index = arry.indexOf(value);
        if (index == -1) {
          arry.push(value);
        } else {
          arry.splice(index, 1);
        }
        var data = {
          id: this.info.id,
          value: arry.sort(),
        };
        this.$emit("choose", data);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/variable.scss";
.choice {
  font-size: 14px;
  .choiceContent {
    .title {
      line-height: 20px;
      margin: 20px 0 15px 0;
      // width: calc(100% - 160px);
    }
    .list {
      .li {
        position: relative;
        box-sizing: border-box;
        padding: 5px 5px 5px 39px;
        line-height: 20px;
        margin: 5px 0;
        cursor: pointer;
        border-radius: 5px;
        .unit {
          position: absolute;
          top: 5px;
          left: 5px;
          width: 22px;
          height: 22px;
          border: 1px solid #999;
          border-radius: 50%;
          font-size: 12px;
        }
        .txt {
          width: 100%;
          word-break: break-all;
          font-size: 14px;
        }
        &.on {
          .unit {
            border-color: $primary;
            background-color: $primary;
            color: #fff;
          }
        }
        &.right {
          border: 2rpx solid rgb(37, 169, 48);
          border-radius: 10rpx;
          background: rgba(37, 169, 48, 0.2);
        }
        &.error {
          border: 2rpx solid rgb(229, 62, 49);
          border-radius: 10rpx;
          background: rgba(229, 62, 49, 0.2);
        }
      }
    }
    .analysisBox {
      box-sizing: border-box;
      padding: 5px 10px;
      border-radius: 5px;
      background: #eee;
      margin: 10px 0;
      div {
        margin: 5px 0;
      }
    }
  }
}
</style>